import { useState } from 'react';
import type { MenuContent, Branding } from '../../../lib/site-schema';

interface Props {
  content: MenuContent;
  branding: Branding | null;
  compact?: boolean;
}

export default function MenuSection({ content, branding, compact }: Props) {
  const [activeTab, setActiveTab] = useState(0);
  const primary = branding?.primaryColor || '#d97706';
  const categories = content.categories || [];

  return (
    <div className={compact ? 'px-4 py-5' : 'px-6 py-10'}>
      {content.heading && (
        <div className="text-center mb-5">
          <h2
            className={`${compact ? 'text-sm' : 'text-xl'} font-bold`}
            style={{ color: '#292524', fontFamily: branding?.fontHeading, letterSpacing: '-0.01em' }}
          >
            {content.heading}
          </h2>
          <div className="w-10 h-0.5 mx-auto mt-2 rounded-full" style={{ background: primary }} />
        </div>
      )}

      {categories.length > 1 && (
        <div className="flex justify-center gap-1 mb-5">
          {categories.map((cat, i) => (
            <button
              key={i}
              onClick={() => setActiveTab(i)}
              className={`${compact ? 'px-3 py-1 text-[10px]' : 'px-4 py-1.5 text-xs'} rounded-full font-semibold transition-all`}
              style={
                activeTab === i
                  ? { background: primary, color: '#fff', boxShadow: `0 2px 8px ${primary}30` }
                  : { background: '#f5f5f4', color: '#78716c' }
              }
            >
              {cat.name}
            </button>
          ))}
        </div>
      )}

      {categories[activeTab] && (
        <div className={`max-w-md mx-auto divide-y`} style={{ borderColor: '#e7e5e4' }}>
          {categories[activeTab].items.map((item, i) => (
            <div
              key={i}
              className={`flex items-start justify-between ${compact ? 'py-2 gap-2' : 'py-3 gap-3'} group`}
              style={{ borderColor: '#f5f5f4' }}
            >
              <div className="min-w-0 flex-1">
                <p
                  className={`${compact ? 'text-[11px]' : 'text-sm'} font-semibold`}
                  style={{ color: '#292524' }}
                >
                  {item.name}
                </p>
                {!compact && item.description && (
                  <p className="text-[11px] mt-0.5" style={{ color: '#a8a29e' }}>{item.description}</p>
                )}
              </div>
              <span
                className={`${compact ? 'text-[11px]' : 'text-sm'} font-bold shrink-0 tabular-nums`}
                style={{ color: primary }}
              >
                {item.price}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
